$(document).ready(function() {
	$('.barkodDiv input.barkodInput').click(function(e){	
		$(this).select();
	});
	
	$('.barkodDiv input.barkodInput').keyup(function(e){
		if(e.which == 13) { //enter
			var barkod = $(this).val();

			var tip = '';
			data = $('.barkodInput').data();
			if (data.tip =='imaUrudzbeni') {
				var tip = 'pismeno';
				if (barkod.substring(0, 1).toUpperCase() == 'D') {tip = 'dokument';}
			}
			else {
				tip = 'dokument';
			}

			var progId = $("#progId").text();
			
			if (tip =='pismeno'){
				konto.uz.api.PismenoObradiBarkod(barkod)
					.then(function(rez){
						if ((rez != undefined) && (rez.error == undefined)){
						simpleStorage.set("cache-" + progId + "-predmetBarkod", { 
							predmet: rez.predmet
		                }); 
						
						if (rez.indikator == 'upozorenje') {
	                            $.dialogGreska({
								content: rez.pitanje
							});	
						}
						else if (rez.indikator != 'default'){	
							var lsLinkOdustani = 'predmet/svi';
							if (rez.indikator == 'PreuzmiPredmet'){lsLinkOdustani = 'predmet/dolazni';}
							else if (rez.indikator == 'PreuzmiPismeno'){lsLinkOdustani = 'pismeno/dolazni';}
							else if (rez.indikator == 'PoslanoNaVanjskuDostavu') {lsLinkOdustani = 'predmet/svi';}
							konto.dialogs.upit({
								title: "Učitan barkod - " + barkod,
								content: rez.pitanje,
								potvrdi: function () {
									if (rez.indikator == 'PreuzmiPredmet'){
										konto.uz.api.PreuzmiPredmet(rez.predmet).then(function(x){
											if (x == null){ //ako nije onda je error
												kontorouter.gotoLocation("predmet/moji");
											}	
										});
									}else if (rez.indikator == 'PreuzmiPismeno'){
										konto.uz.api.PreuzmiPismeno(rez.pismeno, false).then(function(x){
											if (x == null ){ //ako nije onda je error
												kontorouter.gotoLocation("pismeno/moji");
											}	
										});	
									}else if (rez.indikator == 'PoslanoNaVanjskuDostavu'){
										konto.uz.api.FormirajDostavnicuZaDostavnicuS(rez.dostavnicaS).then(function(dostavnica){
											simpleStorage.set("cache-" + progId + "-dostavnicaBarkod", { 
												dostavnica: dostavnica
							                }); 	
											kontorouter.gotoLocation("dostavnica/pregled/2");		
										});	
									}
									
								},
								odustani: function () { 
									kontorouter.gotoLocation(lsLinkOdustani);							
								}
							});
						}else{
							kontorouter.gotoLocation("predmet/svi");	
						}
					}//ako nije error					
					});
				}else{
				     konto.uz.api.DokumentObradiBarkod(barkod).then(function(rez){
				     	if (rez > 0){
							simpleStorage.set("cache-" + progId + "-dokumentFilter", { 
								dokument: rez
			                }); 
			                kontorouter.gotoLocation("dokument/pregled"); 
		                }	
				     });
				}
		}
	});
	
});